import { render, staticRenderFns } from "./UserTab.vue?vue&type=template&id=31e536ef&"
import script from "./UserTab.vue?vue&type=script&lang=js&"
export * from "./UserTab.vue?vue&type=script&lang=js&"
import style0 from "./UserTab.vue?vue&type=style&index=0&id=31e536ef&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports